"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.refusTransportSoinsSheet = void 0;
const utils_1 = require("../../utils");
exports.refusTransportSoinsSheet = [
    {
        '@type': 'tristate',
        key: 'b5ae1986-4fc2-4370-905d-2f830fea11b3',
        label: 'La victime certifie refuser, après avoir reçu une information loyale, claire et appropriée sur les risques ' +
            'encourus du fait de son état, les soins de premiers secours du personnel des sapeurs-pompiers des ' +
            'Bouches-du-Rhône et décharger son personnel de toute responsabilité',
        value: (bilan) => (0, utils_1.boolToChar)(bilan?.refus_transport_soins?.refus_soins),
    },
    {
        '@type': 'tristate',
        key: 'edb32012-ae17-48e2-b29d-3961d851a855',
        label: 'La victime certifie refuser, après avoir reçu une information loyale, claire et appropriée sur les risques ' +
            'encourus du fait de son état, son transport vers un centre hospitalier par un véhicule des sapeurs-pompiers des ' +
            'Bouches-du-Rhônes et décharger son personnel de toute responsabilité',
        value: (bilan) => (0, utils_1.boolToChar)(bilan?.refus_transport_soins?.refus_transport),
    },
    {
        '@type': 'text',
        key: '72d157d3-cf61-40ff-9728-844510570e38',
        label: 'Signature de la victime',
        value: (bilan) => bilan?.refus_transport_soins?.victim_sign,
    },
    {
        '@type': 'table',
        key: 'da3dcf08-7809-498d-98dc-6ebb148ac854',
        label: 'Témoins',
        value: (bilan) => bilan?.refus_transport_soins?.temoins || [],
        template: 'TEMOINS',
    },
];
